import { MDFe, MDFePost, MDFeSearch } from '../interfaces/MDFe';
import { getUrlMDFeApi } from '../utils/util';
import ApiHandler from './ApiHandler';
import ApiHandlerBlob from './ApiHandlerBlob';

export const baseURL = String(getUrlMDFeApi(window));

export default class MDFeApi {

    static async searchMDFe(params: MDFeSearch) {
        var response = await ApiHandler(baseURL).get('mdfe', { params });
        return response.data;
    }

    static async getMDFeDetails(mdfeId: number) {
        var response = await ApiHandler(baseURL).get(`mdfe/${mdfeId}`);
        return response.data;
    }

    static async postMDFe(mdfe: MDFePost) {
        var response = await ApiHandler(baseURL).post('mdfe', mdfe);
        return response.data;
    }

    static async putMDFe(mdfe: MDFe) {
        var response = await ApiHandler(baseURL).put('mdfe', mdfe);
        return response.data;
    }

    static async terminateMDFe(mdfeId: number) {
        var response = await ApiHandler(baseURL).put(`mdfe/terminate/${mdfeId}`);
        return response.data;
    }
    
    static async cancelMDFe(mdfeId: number) {
        var response = await ApiHandler(baseURL).put(`mdfe/cancel/${mdfeId}`);
        return response.data;
    }

    static async getMDFeFile(mdfeId: number) {
        var response = await ApiHandlerBlob(baseURL).get(`mdfe/getmdfefile/${mdfeId}`);
        return response;
    }
}


